import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
import { replaceCitations } from '@Utils/String';
import './SelectedItemsControls.custom.scss';
import './SelectedItemsControls.theme.scss';

export default function SelectedItemsControls(props) {
  const { checkAllItems, allItemsSelected, someItemsSelected, currentSelectedItems, context } = props;

  return (
    <div className="selected-items-controls-wrapper">
      <Checkbox
        label={context ? `${currentSelectedItems} ${replaceCitations(context)} selected` : 'Select all'}
        shouldHideLabel
        onChange={() => {
          checkAllItems(!allItemsSelected);
        }}
        checked={allItemsSelected}
        indeterminate={someItemsSelected}
        // eslint-disable-next-line no-nested-ternary,sonarjs/no-nested-conditional
        aria-checked={allItemsSelected ? 'true' : someItemsSelected ? 'mixed' : 'false'}
      />
      <span className="selected-items-controls-label">
        <span className="selected-items-controls-label-count">{currentSelectedItems}</span>
        <span className="selected-items-controls-label-text hide-below-desktop ">selected</span>
      </span>
    </div>
  );
}

SelectedItemsControls.propTypes = {
  checkAllItems: PropTypes.func.isRequired,
  allItemsSelected: PropTypes.bool.isRequired,
  someItemsSelected: PropTypes.bool,
  currentSelectedItems: PropTypes.number.isRequired,
};
